import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import SingleState from '../states/single.state';

interface SettingsData {
    [key: string]: any;
}

const initialState: SingleState = {
    data: {},
    loading: false,
    error: null,
};

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        setSettingsData: (state, action: PayloadAction<SettingsData>) => {
            return {
                ...state,
                data: action.payload
            };
        },
        resetSettingsData: (state) => {
            return {
                ...state,
                data: {}
            };
        },
    },
});

export const { setSettingsData, resetSettingsData} = settingsSlice.actions;
export default settingsSlice.reducer;
